<template>
  <vs-dropdown  vs-custom-content vs-trigger-click class="cursor-pointer mr-3">
    <span class="cursor-pointer flex items-center i18n-locale">
      <span class="ml-2 locale-text">{{ getCurrentLocaleData.lang }}</span>
    </span>
    <vs-dropdown-menu class="w-24 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item @click="updateLocale('en')">EN</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('fr')">FR</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  computed: {
    i18n_locale_img () {
      // Use below code to dynamically fetch image instead of if-else
      // NOTE: We used if-else because laravel throws error in 'yarn prod'.
      // If you are not using laravel + Vue, you can use below code to dynamically get image
      // return require(`@/assets/images/flags/${this.$i18n.locale}.png`)

      const locale = this.$i18n.locale
      if (locale.startsWith('en'))      return require('@/assets/images/flags/en.png')
      else if (locale.startsWith('fr')) return require('@/assets/images/flags/fr.png')
      else return require('@/assets/images/flags/en.png')
    },
    getCurrentLocaleData () {
      const locale = this.$i18n.locale
      if (locale.startsWith('en'))      return { flag: 'us', lang: 'EN'    }
      else if (locale.startsWith('fr')) return { flag: 'fr', lang: 'FR'     }
      else return  { flag: 'us', lang: 'EN'    }
    }
  },
  methods: {
    updateLocale (locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('lang', locale)
      this.$forceUpdate();  
    }
  }
}
</script>
<style lang="scss">
  .locale-text {
    font-family: Montserrat, Helvetica, Arial, sans-serif;
  }
</style>
